export default __webpack_public_path__ + "static/media/rington2.66ef359f.mp3";